import React, { useState } from 'react'
import { Navbar, Collapse, Icon } from '@blueprintjs/core'
import {
    JobsHamburgerItems,
    InventoryHamburgerItems,
    ReportsHamburgerItems,
    DigitalBoardHamburgerItems,
    UtilityShortcutHamburgerItems,
    AdminHamburgerItems, navHeaderStyle
} from './shared'
import ScrollToTopButton from '../ScrollToTopButton'
import { slide as Burger } from 'react-burger-menu'
import {
    CanAdministerUsers, CanViewJobMenu, CanViewReportsMenu, CanViewScheduleMenu,
    CanViewInventoryMenu, CanViewMapSearchMenu, CanViewAdminDashboard
} from '../../Components/Auth'
import { NavButtonLink, Row, Divider, NavButton } from '../../Elements'
import { useAuth0 } from '../../Hooks/auth0'
import { useOnlineUtils } from '../../Hooks/offline'
// import { OfflineDownloader } from '../../Components'
import Notifications from '../../Components/Notifications'
import { useLocalStorage } from '../../Hooks/offline'
import { logoNav, primaryTheme, envShowCentralTexas } from '../../utils/helpers'


const burgerStyles = {
    bmBurgerButton: {
        width: '36px',
        height: '30px',
        position: 'fixed',
        top: '10px',
        right: '2vw',
        textAlign: 'right'
    },
    bmBurgerBars: {
        background: primaryTheme,
        borderRadius: '50px'
    },
    bmCrossButton: {
        height: '24px',
        width: '24px',
        position: 'relative',
        top: '-99vh',
        right: '-27vw',
        backgroundColor: '#ffffffa1',
        borderRadius: '50px'
    },
    bmCross: {
        background: primaryTheme
    },
    bmMenuWrap: {
        position: 'fixed',
        height: '100vh',
        top: '0px',
        width: '60vw'
    },
    bmIcon: {
        height: 'inherit',
        textAlign: 'right',
    },
    bmMenu: {
        background: 'white',
        paddingTop: '2.5em',
        fontSize: '1.15em',
        overflowX: 'hidden'
    },
    bmMorphShape: {
        fill: '#373a47'
    },
    bmItemList: {
        color: '#b8b7ad',
    },
    bmItem: {
        display: 'block',
        textAlign: 'center'
    },
    bmOverlay: {
        top: '0px',
        left: '0px'
    }
}

const Collapsable = ({ children, className, triggerIcon, triggerText }) => {
    const [isOpen, setIsOpen] = useState(false)
    return <>
        <NavButton
            style={{ width: '100%' }}
            icon={'' || triggerIcon}
            text={'' || triggerText}
            onClick={() => setIsOpen(!isOpen)}
            rightIcon={isOpen ? 'caret-up' : 'caret-down'}
        />
        <Collapse className={className} isOpen={isOpen} children={children} />
    </>
}

const MobileNavbar = () => {
    const { isLoggedIn } = useAuth0()
    const { isOnline } = useOnlineUtils()
    const { clearAppStorage } = useLocalStorage()

    return (
        <Navbar className={isOnline ? 'online-navbar' : 'offline-navbar'} >
            <Navbar.Group style={{ width: '100%' }}>
                <Navbar.Heading className='heading'>
                    {isOnline && <a href="/">
                        {envShowCentralTexas
                            ? <img src={logoNav} width='100%' alt='MMG' style={{ marginTop: 10 }} />
                            : <object type="image/svg+xml" data={logoNav} alt='MMG' width='55px' height='55px' />
                        }
                    </a>}
                    {!isOnline && <Icon icon='offline' size='40' color='red' style={{ marginTop: 10 }} />}
                    <a style={navHeaderStyle} href='/'>Insite</a>
                </Navbar.Heading>
                {!isOnline &&
                    <Navbar.Divider style={{ display: 'inline-block' }} />
                }

                {!isOnline &&
                    <Navbar.Heading className="heading" style={{ ...navHeaderStyle, whiteSpace: 'nowrap', color: 'red' }}>
                        <b>OFFLINE MODE</b>
                    </Navbar.Heading>
                }
                <ScrollToTopButton />

                {isLoggedIn() &&
                    <Burger
                        right
                        styles={burgerStyles}
                    >
                        <CanViewJobMenu>
                            <Row>
                                <Collapsable
                                    triggerText='Jobs'
                                    triggerIcon='briefcase'
                                    className='collapsable-menu-content'
                                    children={<JobsHamburgerItems />}
                                />
                            </Row>
                        </CanViewJobMenu>

                        {isOnline &&
                            <Row>
                                <CanViewMapSearchMenu>
                                    <NavButtonLink icon='globe' text='Search' to='/map' />
                                </CanViewMapSearchMenu>
                            </Row>
                        }

                        <CanViewInventoryMenu>
                            {isOnline &&
                                <Row>
                                    <Collapsable
                                        triggerText='Inventory'
                                        triggerIcon='shopping-cart'
                                        className='collapsable-menu-content'
                                        children={<InventoryHamburgerItems />}
                                    />
                                </Row>
                            }
                        </CanViewInventoryMenu>

                        <CanViewReportsMenu>
                            {isOnline && <>
                                <Row>
                                    <Collapsable
                                        triggerText='Reports'
                                        triggerIcon='series-derived'
                                        className='collapsable-menu-content'
                                        children={<ReportsHamburgerItems />}
                                    />
                                </Row>
                                <Divider />
                            </>
                            }
                        </CanViewReportsMenu>

                        <CanViewScheduleMenu>
                            {isOnline && <>
                                <Row>
                                    <Collapsable
                                        triggerText='Schedule'
                                        triggerIcon='timeline-events'
                                        className='collapsable-menu-content'
                                        children={<DigitalBoardHamburgerItems />}
                                    />
                                </Row>
                                <Divider />
                            </>
                            }
                        </CanViewScheduleMenu>


                        {isOnline &&
                            <Row>
                                <CanAdministerUsers>
                                    <NavButtonLink icon='user' text='Users' to='/user' />
                                </CanAdministerUsers>
                            </Row>
                        }

                        <CanAdministerUsers>
                            {isOnline &&
                                <Row>
                                    <Collapsable
                                        triggerText='Utility'
                                        triggerIcon='wrench'
                                        className='collapsable-menu-content'
                                        children={<UtilityShortcutHamburgerItems />}
                                    />
                                </Row>
                            }
                        </CanAdministerUsers>

                        <CanViewAdminDashboard>
                            {isOnline &&
                                <Row>
                                    <Collapsable
                                        triggerText='Admin'
                                        triggerIcon='shield'
                                        className='collapsable-menu-content'
                                        children={<AdminHamburgerItems />}
                                    />
                                </Row>
                            }
                        </CanViewAdminDashboard>


                        <Divider />

                        {/* <OfflineDownloader /> */}


                        {!isOnline &&
                            <Divider />
                        }
                        <Row>
                            <Notifications />
                        </Row>
                        <Divider />
                        {isOnline && <span title='Clean Local Storage'><Icon style={{ marginRight: '10px', cursor: 'pointer' }} icon={'clean'} onClick={clearAppStorage} /></span>}

                        <Row >
                            <MobileLogoutButton />
                        </Row>
                    </Burger>
                }
            </Navbar.Group>
        </Navbar>
    )
}

const MobileLogoutButton = () => {
    const { logout, profile } = useAuth0()

    return <NavButtonLink
        icon='log-out'
        onClick={logout}
        text={`Logout ${profile.name}`}
    />
}

export { MobileNavbar }